import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const A = styled.a`
  cursor: pointer;

  ${(props) => (props.type === 'aside' && css`
    display: block;
    height: 100%;
    font-size: 16px;
    font-weight: 800;
    line-height: 35px;
    letter-spacing: -1px;

    &.act {
      background-color: #fdce00;
    }
  `)}

  ${(props) => (props.type === 'asideIn' && css`
    display: block;
    font-size: 18px;
    text-align: center;
    font-weight: 600;
    line-height: 40px;

    &.act {
      background-color: #fdce00;
    }
  `)}

  ${(props) => (props.type === 'animation' && css`
    display: block;
    font-size: 18px;
    text-align: center;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -1px;

    &.act {
      background-color: #fdce00;
    }
  `)}

  ${(props) => props.type === 'unit' && css`
    display: block;
    color: #d2d2d2;
    text-align: center;
    padding: 15px 0;
    font-size: 30px;
    font-weight: 600;

    ${props.page && css`
      height: 82px;
    `}

    &.act {
      color: #fff;
      background-color: #5493fc;
    }
  `}

  ${(props) => props.type === 'track' && css`
    display: block;
    padding: 5px 0;
    font-size: 28px;
    color: #d2d2d2;
    text-align: center;

    ${props.page && css`
      height: 82px;
      line-height: 82px;
    `}

    &.act {
      color: #5493fc;
      background-color: #ddeaff;
    }
  `}
`;

export const Anchor = (props) => {
  return (
    <A 
      type={props.type} 
      className={props.className} 
      onClick={props.onClick}
      page={props.page}
    >
      {props.children}
    </A>
  );
};

Anchor.propTypes = {
  type : PropTypes.string,
  className : PropTypes.string
};

Anchor.defaultProps = {
  type : 'aside'
};
